import React, {FC} from 'react'

import {observer} from 'mobx-react-lite'

import Checkbox, {ICheckboxProps} from 'components/elements/fields/Checkbox/Checkbox'

interface IMobxCheckboxProps extends ICheckboxProps {
	name: string
	checked?: boolean
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: any
}

const MobxCheckbox: FC<IMobxCheckboxProps> = ({name, store, checked, onChange, ...props}) => {
	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (onChange) {
			onChange(e)
		} else {
			store[name] = e.target.checked
		}
	}
	return (
		<Checkbox
			checked={checked !== undefined ? checked : store[name]}
			name={name}
			onChange={onChangeHandler}
			{...props}
		/>
	)
}

MobxCheckbox.displayName = 'MobxCheckbox'

export default observer(MobxCheckbox)
